import { type DomainMessages, useDomainIntl } from 'domains/collections/utils/domain/intl'

export type SelectOptionType = { labelKey: DomainMessages; value: string }

export type SelectOptionTypeIntl = {
  label: string
  value: string
}

export const useSelectOptionsDashMessage = (
  options: SelectOptionType[]
): SelectOptionTypeIntl[] => {
  const intl = useDomainIntl()

  return options.map(({ value, labelKey }) => ({
    value,
    label: intl.formatMessage({ id: labelKey as DomainMessages }),
  }))
}

// for now, these aren't coming from codegen
export const displayStyleOptions: SelectOptionType[] = [
  {
    value: 'graphics_browse_header',
    labelKey: 'collectionsDomain.collectionsForm.section.header.displayStyle.graphics',
  },
  {
    value: 'hero_browse_header',
    labelKey: 'collectionsDomain.collectionsForm.section.header.displayStyle.hero',
  },
  {
    value: 'browse_header',
    labelKey: 'collectionsDomain.collectionsForm.section.header.displayStyle.browse',
  },
]
